import React from 'react'
import styled from 'styled-components'
import FinanceMetricCard from './foundation/FinanceMetricCard'

interface StatItem {
  label: string
  value: string
  tone?: 'default' | 'success' | 'warning' | 'danger'
}

interface Props {
  items: StatItem[]
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
`

const FinanceStatsStrip: React.FC<Props> = ({ items }) => (
  <Grid>
    {items.map((item) => (
      <FinanceMetricCard
        key={item.label}
        label={item.label}
        value={item.value}
        tone={item.tone || 'default'}
      />
    ))}
  </Grid>
)

export default FinanceStatsStrip
